import type { AnimatedImageCustomInput } from "@repo/api/animated-image";
import type { SourceImageCustomInput } from "@repo/api/source-image";

export enum ActionIdentifier {
  NAVIGATE_START_IMAGE = "NAVIGATE_START_IMAGE",
  NAVIGATE_END_IMAGE = "NAVIGATE_END_IMAGE",
  NAVIGATE_ANIMATION = "NAVIGATE_ANIMATION",
  ADD_START_IMAGE = "ADD_START_IMAGE",
  ADD_END_IMAGE = "ADD_END_IMAGE",
  SELECT_ELEMENTS = "SELECT_ELEMENTS",
  GENERATE_IMAGE = "GENERATE_IMAGE",
  ANIMATE_VIDEO = "ANIMATE_VIDEO",
  NONE = "NONE",
}

export interface InspirationGuideStep {
  title: string;
  description: string;
  actionIdentifier: ActionIdentifier;
}

export interface InspirationAnimationPrompt {
  id: string;
  name: string;
  customInput: AnimatedImageCustomInput;
  hasPreviewVideo?: boolean;
}

export interface InspirationImagePrompt {
  id: string;
  name: string;
  customInput: SourceImageCustomInput;
  hasPreviewVideo?: boolean;
}

export interface InspirationGuide {
  id: string;
  title: string;
  description: string;
  steps: InspirationGuideStep[];
  animationPrompts?: InspirationAnimationPrompt[];
  imagePrompts?: InspirationImagePrompt[];
  hasPreviewVideo?: boolean;
}

export interface CreativeProjectAnimationForm {
  prompt: string;
  duration: number;
}

export interface CreativeProjectImageEditForm {
  prompt: string;
  numGeneratedImages: number;
  elementExternalIds: string[];
}

export interface CreativeProjectState {
  animationForm: CreativeProjectAnimationForm;
  startImageEditForm: CreativeProjectImageEditForm;
  endImageEditForm: CreativeProjectImageEditForm;
}

export interface CreativeProjectSheetState {
  isSheetOpen: boolean;
  currentCreativeProjectExternalId: string | null;
  creativeProjects: Record<string, CreativeProjectState>;
}

export function applyAnimatedImageCustomInput(
  draft: CreativeProjectState,
  input: AnimatedImageCustomInput,
) {
  draft.animationForm.prompt = input.prompt;
  draft.animationForm.duration = input.duration;
}

export function applySourceImageCustomInput(
  draft: CreativeProjectState,
  sourceImageKey: "startSourceImageExternalId" | "endSourceImageExternalId",
  input: SourceImageCustomInput,
) {
  const formKey =
    sourceImageKey === "startSourceImageExternalId"
      ? "startImageEditForm"
      : "endImageEditForm";
  draft[formKey].prompt = input.prompt;
}
